const initState = {
  currentForm: "primaryUser",
  formValidity: false,
  phoneValidity: false,
  onBoardedStatus: false,
  onBoardDetails: {},
  onBoardError: false,
  reqtriggered: false,
  obBoardErrorReason: "Due to a technical issue, we are temporarily unable to process your request. We are working to resolve this as quickly as possible. Please check back in a few minutes.",
  customer: {
    name: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    countryCode: {
      country_id: "",
      label: "",
      country_isd_code: "",
      value: "",
    },
    state: "",
    city: "",
    postalCode: "",
    county: "",
  },
  primaryUser: {
    email: "",
    firstName: "",
    lastName: "",
    phone: {
      countryCode: "",
      number: "",
      isdnCode: "",
    },
  },
};

export default initState;
